import { getIn } from 'formik';
import React from 'react';
import { useItemCreationContext } from '~/ModularComponents/ItemCreation/ItemCreation';
import { Typography } from '~/UIKit';
import { ItemCreationInputTemplateStyles } from './ItemCreationInputTemplate.styles';
import { CircularProgress } from '@mui/material';

interface IItemCreationInputTemplateProps<T> {
  name: keyof T;
  InputElement: JSX.Element;
  label?: string;
  icon?: JSX.Element;
  children?: JSX.Element | JSX.Element[];
  noIconBackground?: boolean;
  isAChild?: boolean;
  isLoading?: boolean;
}

export const ItemCreationInputTemplate = <T extends object>({
  icon,
  label,
  name,
  children,
  noIconBackground,
  isAChild,
  InputElement,
  isLoading = false,
}: IItemCreationInputTemplateProps<T>) => {
  const { errors, touched, disabled } = useItemCreationContext();

  const error = getIn(errors, name as string);
  const isTouched = getIn(touched, name as string);
  const isDisabled = getIn(disabled, name as string);
  const hasItemIcon = !!InputElement.props.icon;
  const hasItemLabel = !!InputElement.props.label;

  const { classes } = ItemCreationInputTemplateStyles({
    isAChild: !!isAChild,
    icon,
    noIconBackground,
    isDisabled,
    error: isTouched && error,
  })();

  return (
    <div className={classes.inputContainer}>
      <div className={classes.singleInputContainer}>
        {icon && !hasItemIcon && <div className={classes.inputIcon}>{icon}</div>}
        {!hasItemLabel && <Typography className={classes.typographyBody}>{label}</Typography>}
        {InputElement}
        {isLoading && <CircularProgress className={classes.progress} />}
      </div>
      {children}
    </div>
  );
};
